export default {
  accountInfo: {},
  logged: false,
  pricings: [],
  activeProjectNumber: null,
  inactiveProjectNumber: null,
  firstProject: null,
  lastProject: null,
  s3Credentials: {
    'AccessKeyId': '',
    'SecretAccessKey': '',
    'SessionToken': '',
    'Expiration': ''
  },
  bucket: ''
}



// WEBPACK FOOTER //
// ./src/components/account/store/state.js